<template>
  <div class="wrap-lg">
    <div class="boxs-top clearfix">
      <div class="top-title"><span>合作单位</span></div>
      <div class="top-more">
        <my-link href="/reunit">
          查看更多
          <i class="el-icon-arrow-right"></i>
        </my-link>
      </div>
    </div>
    <div class="top-divider"></div>
      <div class="list-unit">
        <div class="item-unit" v-for="item in adsPic" :key="item.id" :title="item.title">
          <img :src="item.imgUrl">
        </div>
      </div>
  </div>
</template>

<script>
import { getLists } from '@/api/ads/adsPics'
export default {
  name: 'recommendUnit',
  data () {
    return {
      adsPic: []
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    initData: function () {
      // 初始化数据
      let params = {}
      params.categoryCode = '5'
      getLists(params).then(res => {
        this.loading = false
        var result = res.data
        if (result.rtnCode !== '0') {
          this.$message({
            type: 'info',
            message: result.msg
          })
        } else {
          if (result.bizData.length > 10) {
            this.adsPic = result.bizData.slice(0, 10)
          } else {
            this.adsPic = result.bizData
          }
        }
      }).catch(ex => {
        this.loading = false
        this.$message.error('列表加载失败，请稍后再试！')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .list-unit {
    width: 100%;
    overflow: hidden;
    margin-top: 20px;
    .item-unit {
      background: #ffffff;
      width: 241px  ;
      height: 100px;
      float: left;
      text-align: center;
      margin: 2px;
      &:hover {
        box-shadow: 0px 0px 15px 0px rgba(2, 91, 75, 0.2);
      }
      img{
        margin: 15px 5px;
        height: 70px;
      }
    }
  }
</style>
